/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { JobBasketCardData } from '@xing-com/crate-dream-machine-types';
import type { JobTeaserVisibleJobFragment } from '@xing-com/crate-jobs-graphql';

import {
  isValidSalary,
  isValidSalaryEstimate,
  isValidSalaryRange,
} from './salary';

const NOT_BOOKMARKED = 'NOT_BOOKMARKED';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectAvailableJobData = (job: JobTeaserVisibleJobFragment) => {
  const { companyInfo, salary, activatedAt, refreshedAt, title, location } =
    job;

  const companyName = companyInfo?.companyNameOverride;
  const companyLogo = companyInfo?.company?.logos?.x1 || '';
  const ratingAverage = companyInfo?.company?.kununuData?.ratingAverage;
  const employmentTypeValue = job.employmentType?.localizationValue;
  const bookmarkState = job.userInteractions?.bookmark?.state ?? NOT_BOOKMARKED;
  const isBookmarked = bookmarkState !== NOT_BOOKMARKED;

  const showSalary =
    isValidSalary(salary) ||
    isValidSalaryRange(salary) ||
    isValidSalaryEstimate(salary);

  return {
    salary,
    showSalary,
    activatedAt,
    refreshedAt,
    title,
    location,
    companyName,
    companyLogo,
    ratingAverage,
    employmentTypeValue,
    isBookmarked,
  };
};

const selectBasketCardData = (
  job: JobBasketCardData
): ReturnType<typeof selectAvailableJobData> => {
  const showSalary =
    isValidSalary(job.salary) ||
    isValidSalaryRange(job.salary) ||
    isValidSalaryEstimate(job.salary);

  return {
    salary: job.salary,
    showSalary: showSalary,
    activatedAt: job.activatedAt,
    refreshedAt: job.refreshedAt || '',
    title: job.jobTitle || '',
    location: { city: job.location },
    companyName:
      job?.company?.companyName || job?.fallbackCompany?.companyName || '',
    companyLogo: job.companyLogo || '',
    ratingAverage: job.company?.kununuData?.ratingAverage,
    employmentTypeValue: undefined,
    isBookmarked: false,
  };
};

export const selectJobData = (
  job: JobBasketCardData | JobTeaserVisibleJobFragment
): ReturnType<typeof selectAvailableJobData> => {
  if (job.__typename === 'JobBasketCardData') {
    return selectBasketCardData(job);
  }
  return selectAvailableJobData(job);
};
